import React, { useEffect, useRef } from "react";
import { gsap } from "./../../lib/index";

export default function SubHero() {
    const sectionRef = useRef(null);
    const aboutTextRef = useRef(null);
    const taglineRef = useRef(null);
    const btnWrapperRef = useRef(null);
    const glowRef = useRef(null);

    useEffect(() => {
        const aboutText = aboutTextRef.current;
        const tagline = taglineRef.current;
        const buttonWrapper = btnWrapperRef.current;
        const section = sectionRef.current;
        const glow = glowRef.current;

        if (aboutText) {
            const text = aboutText.textContent?.trim() || "";
            const hasProcessed = aboutText.querySelector(".letter");

            if (!hasProcessed) {
                aboutText.innerHTML = text
                    .split(" ")
                    .map(word =>
                        `<span class="word inline-block">${word.split("").map(letter => `<span class="letter inline-block">${letter}</span>`).join("")}</span>`
                    )
                    .join(" ") + " ";

                const letters = aboutText.querySelectorAll(".letter");
                gsap.set(letters, { opacity: 0.2 });

                gsap.timeline({
                    scrollTrigger: {
                        trigger: aboutText,
                        start: "top 90%",
                        end: "bottom 60%",
                        scrub: 1,
                    },
                }).to(letters, {
                    opacity: 1,
                    duration: 0.4,
                    stagger: 0.02,
                    ease: "power2.out",
                });
            }
        }

        const animateElement = (element, trigger, start, end, fromProps) => {
            if (element) {
                gsap.timeline({
                    scrollTrigger: {
                        trigger,
                        start,
                        end,
                        once: true,
                    },
                }).from(element, fromProps);
            }
        };

        animateElement(tagline, tagline, "top 90%", "top 50%", { y: 20, opacity: 0, duration: 0.6, ease: "power2.out" });
        animateElement(buttonWrapper, tagline, "top 50%", "top 30%", { y: 50, opacity: 0, duration: 1, ease: "power2.out" });

        // Glow effect on scroll
        if (section && glow) {
            gsap.to(glow, {
                opacity: 1,
                duration: 1,
                scrollTrigger: {
                    trigger: section,
                    start: "top 80%",
                    end: "bottom 20%",
                    scrub: true,
                }
            });
        }

        // Mobile background fix
        const handleResize = () => {
            if (section) {
                if (window.innerWidth <= 768) {
                    section.style.backgroundAttachment = 'scroll';
                } else {
                    section.style.backgroundAttachment = 'fixed';
                }
            }
        };

        handleResize(); // Initial check
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);

    }, []);

    return (
        <section 
            ref={sectionRef} 
            className="relative min-h-screen h-fit overflow-hidden bg-cover bg-center bg-no-repeat px-4 md:px-8"
            style={{ backgroundImage: 'url(/textbg.jpg)' }}
        >
            <div 
                className="flex flex-col items-center justify-center min-h-screen h-fit w-full text-center bg-black bg-opacity-50 backdrop-blur-md rounded-lg overflow-hidden relative z-10 my-4 md:my-8 p-8 md:p-16"
            >
                <div ref={taglineRef}>
                    {/* Tagline content here */}
                </div>
                <h2 
                    ref={aboutTextRef}
                    className="text-2xl sm:text-4xl md:text-6xl lg:text-7xl xl:text-[2.75rem] mt-6 md:mt-8 max-w-6xl w-full leading-tight md:leading-normal text-white text-shadow-lg"
                >
                    FuteurAI empowers 34.8 million small businesses to lead, thrive, and
                    dominate with AI-driven credit insights, unaltered reports, and 
                    actionable strategies. No gimmicks—just clarity, transparency, and 
                    results to help businesses grow and excel in today's fast-paced world.
                </h2>
                <div 
                    ref={btnWrapperRef}
                    className="mt-8 md:mt-12"
                >
                    {/* Button content here */}
                </div>
            </div>
            <div 
                ref={glowRef}
                className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[150%] h-[150%] bg-radial-gradient from-white to-transparent opacity-0 pointer-events-none z-0"
            ></div>
        </section>
    );
}

